import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { fetchTaxonomies } from '../api/client';

const TaxonomiesContext = createContext(null);

export const TaxonomiesProvider = ({ children }) => {
  const [types, setTypes] = useState([]);
  const [collections, setCollections] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await fetchTaxonomies();
      const g = data.grouped || { type: [], collection: [], category: [] };
      setTypes(g.type || []);
      setCollections(g.collection || []);
      setCategories(g.category || []);
    } catch (err) {
      console.warn('[Taxonomies] fetch failed:', err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ types, collections, categories, loading, refresh }), [types, collections, categories, loading, refresh]);

  return <TaxonomiesContext.Provider value={value}>{children}</TaxonomiesContext.Provider>;
};

export const useTaxonomies = () => {
  const ctx = useContext(TaxonomiesContext);
  if (!ctx) throw new Error('useTaxonomies must be used within TaxonomiesProvider');
  return ctx;
};
